@if(item.onClick && item.onIconClick) {
<button mat-menu-item class="btn" [ngClass]="{'multiline': multiline}" (click)="item.onClick()">
    <div class="menu-item">
        <span>{{item.name | translate}}</span>

        <button mat-icon-button (click)="$event.stopPropagation(); item.onIconClick()">
            <mat-icon *ngIf="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
            <mat-icon *ngIf="!item.svgIcon">{{item.icon}}</mat-icon>
        </button>
    </div>
</button>

} @else if(item.onClick) {
<button mat-menu-item (click)="item.onClick()" class="btn" [ngClass]="{'multiline': multiline}">
    <div class="menu-item">
        <span>{{item.name | translate}}</span>
    </div>
</button>

} @else if(item.route) {
<button mat-menu-item [routerLink]="item.route" class="btn">
    <div class="menu-item">
        <mat-icon *ngIf="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
        <mat-icon *ngIf="!item.svgIcon && item.icon">{{item.icon}}</mat-icon>
        {{item.name | translate}}
    </div>
</button>

} @else if(item.url) {
<a mat-menu-item href="{{item.url}}" target="_blank" class="btn">
    <div class="menu-item">
        <mat-icon *ngIf="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
        <mat-icon *ngIf="!item.svgIcon && item.icon">{{item.icon}}</mat-icon>
        {{item.name | translate}}
    </div>
</a>

} @else {
<button mat-menu-item [matMenuTriggerFor]="childMenu" [matMenuTriggerRestoreFocus]="false">
    <mat-icon *ngIf="item.svgIcon" [svgIcon]="item.svgIcon"></mat-icon>
    <mat-icon *ngIf="!item.svgIcon && item.icon">{{item.icon}}</mat-icon>
    {{item.name | translate}}
</button>

<mat-menu #childMenu="matMenu" class="side-menu">
    <app-menu-item *ngFor="let child of item.children" [item]="child"></app-menu-item>
</mat-menu>
}

@if(item.divide) {
<mat-divider></mat-divider>
}